module.exports = __webpack_public_path__ + "static/img/1.ef97c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zsdh/1.png
// module id = 0Nxy
// module chunks = 0